/* ============================================
   VADERFINDDS THEME JS
   ============================================ */

(function() {
  'use strict';

  /* ---- STARFIELD BACKGROUND ---- */
  const starfield = document.getElementById('starfield');
  if (starfield) {
    const ctx = starfield.getContext('2d');
    let stars = [];
    let animationId;

    function resize() {
      starfield.width = window.innerWidth;
      starfield.height = window.innerHeight;
    }

    function createStars() {
      stars = [];
      const count = Math.min(150, Math.floor((window.innerWidth * window.innerHeight) / 10000));
      for (let i = 0; i < count; i++) {
        stars.push({
          x: Math.random() * starfield.width,
          y: Math.random() * starfield.height,
          size: Math.random() * 1.5 + 0.3,
          opacity: Math.random() * 0.8 + 0.2,
          vx: (Math.random() - 0.5) * 0.15,
          vy: (Math.random() - 0.5) * 0.15,
          pulse: Math.random() * 0.02 + 0.005,
          pulseOffset: Math.random() * Math.PI * 2
        });
      }
    }

    function animate(time) {
      ctx.clearRect(0, 0, starfield.width, starfield.height);
      stars.forEach(star => {
        star.x += star.vx;
        star.y += star.vy;
        if (star.x < 0) star.x = starfield.width;
        if (star.x > starfield.width) star.x = 0;
        if (star.y < 0) star.y = starfield.height;
        if (star.y > starfield.height) star.y = 0;

        const pulsed = star.opacity * (0.6 + Math.sin(time * star.pulse + star.pulseOffset) * 0.4);
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(220, 230, 255, ${pulsed})`;
        ctx.fill();
      });
      animationId = requestAnimationFrame(animate);
    }

    resize();
    createStars();
    animate(0);

    window.addEventListener('resize', () => {
      resize();
      createStars();
    });
  }

  /* ---- CURSOR GLOW ---- */
  const cursorGlow = document.getElementById('cursorGlow');
  if (cursorGlow && window.matchMedia('(pointer: fine)').matches) {
    let mouseX = 0, mouseY = 0;
    let glowX = 0, glowY = 0;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

    function updateGlow() {
      glowX += (mouseX - glowX) * 0.15;
      glowY += (mouseY - glowY) * 0.15;
      cursorGlow.style.left = glowX + 'px';
      cursorGlow.style.top = glowY + 'px';
      requestAnimationFrame(updateGlow);
    }
    updateGlow();

    // Expand on hover over interactive elements
    document.addEventListener('mouseover', (e) => {
      if (e.target.closest('a, button, .product-card, .variant-btn')) {
        cursorGlow.style.width = '40px';
        cursorGlow.style.height = '40px';
        cursorGlow.style.opacity = '1';
      }
    });
    document.addEventListener('mouseout', (e) => {
      if (e.target.closest('a, button, .product-card, .variant-btn')) {
        cursorGlow.style.width = '20px';
        cursorGlow.style.height = '20px';
        cursorGlow.style.opacity = '0.6';
      }
    });
  } else if (cursorGlow) {
    cursorGlow.style.display = 'none';
  }

  /* ---- HEADER SCROLL EFFECT ---- */
  const header = document.querySelector('.header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      if (currentScroll > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ---- MOBILE MENU ---- */
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuClose = document.querySelector('.mobile-menu__close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  /* ---- PRODUCT TABS ---- */
  document.querySelectorAll('.tabs__nav').forEach(nav => {
    const buttons = nav.querySelectorAll('.tab__btn');
    const contents = nav.parentElement.querySelectorAll('.tab__content');

    buttons.forEach((btn, idx) => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));
        btn.classList.add('active');
        if (contents[idx]) contents[idx].classList.add('active');
      });
    });
  });

  /* ---- PRODUCT GALLERY ---- */
  const galleryMain = document.querySelector('.product-gallery__main img');
  const galleryThumbs = document.querySelectorAll('.product-gallery__thumb');

  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img').src;
      const fullSrc = thumb.dataset.full || src;
      if (galleryMain) {
        galleryMain.style.opacity = '0';
        setTimeout(() => {
          galleryMain.src = fullSrc;
          galleryMain.style.opacity = '1';
        }, 150);
      }
      galleryThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ---- VARIANT SELECTION ---- */
  document.querySelectorAll('[data-variant-group]').forEach(group => {
    const buttons = group.querySelectorAll('.variant-btn');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // Update displayed variant label
        const label = group.previousElementSibling;
        if (label && label.classList.contains('variant-label')) {
          const span = label.querySelector('span');
          if (span) span.textContent = btn.dataset.value || btn.textContent;
        }

        // Trigger variant update event
        const event = new CustomEvent('variant:change', {
          detail: {
            optionName: group.dataset.optionName,
            value: btn.dataset.value || btn.textContent.trim()
          }
        });
        document.dispatchEvent(event);
      });
    });
  });

  /* ---- QUANTITY CONTROLS ---- */
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('.quantity-input');
    const minusBtn = selector.querySelector('[data-qty="minus"]');
    const plusBtn = selector.querySelector('[data-qty="plus"]');

    if (minusBtn) minusBtn.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (plusBtn) plusBtn.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---- SCROLL REVEAL ---- */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  /* ---- 3D TILT EFFECT ON PRODUCT CARDS ---- */
  if (window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.product-card').forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = ((y - centerY) / centerY) * -3;
        const rotateY = ((x - centerX) / centerX) * 3;
        card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-8px) scale(1.01)`;
      });

      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
      });
    });
  }

  /* ---- NEWSLETTER FORM ---- */
  document.querySelectorAll('.footer__newsletter-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      // Shopify form handling is native; just add feedback
      const btn = form.querySelector('.newsletter-btn');
      if (btn) {
        const originalText = btn.textContent;
        btn.textContent = 'SENDING...';
        setTimeout(() => {
          btn.textContent = originalText;
        }, 2000);
      }
    });
  });

  /* ---- SABER BEAM DECORATIONS ---- */
  function addSaberBeams() {
    const heroes = document.querySelectorAll('.hero');
    heroes.forEach(hero => {
      for (let i = 0; i < 3; i++) {
        const beam = document.createElement('div');
        beam.className = 'saber-beam' + (i % 2 ? ' saber-beam--red' : '');
        beam.style.left = (15 + i * 30) + '%';
        beam.style.top = '0';
        beam.style.height = '100%';
        beam.style.animationDelay = (i * 0.3) + 's';
        hero.appendChild(beam);
      }
    });
  }
  addSaberBeams();

  /* ---- FAQ ACCORDION ---- */
  document.querySelectorAll('.faq-item__question').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.closest('.faq-item');
      const wasActive = item.classList.contains('active');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('active'));
      if (!wasActive) item.classList.add('active');
    });
  });

  /* ---- SMOOTH SCROLL ON ANCHOR LINKS ---- */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#' || href === '#0') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const offset = 100;
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* ---- NOTIFICATION SYSTEM ---- */
  window.vaderFindds = window.vaderFindds || {};
  window.vaderFindds.notify = function(message, type = 'success') {
    const existing = document.querySelector('.notification');
    if (existing) existing.remove();

    const notif = document.createElement('div');
    notif.className = 'notification';
    notif.innerHTML = `
      <span class="notification__icon">${type === 'success' ? '✓' : '!'}</span>
      <span class="notification__text">${message}</span>
    `;
    document.body.appendChild(notif);
    setTimeout(() => notif.classList.add('show'), 10);
    setTimeout(() => {
      notif.classList.remove('show');
      setTimeout(() => notif.remove(), 400);
    }, 3500);
  };

})();
